<div class="base-slider owl-carousel owl-theme bg-gray">
  <div class="item">
    <img src="assets/images/slider-light.svg" alt="slider">
    <div class="inside">
      <h2>OCTOPUS</h2>
      <p>Лучший провайдер по оценке клиентов</p>
      <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn">Начать пользоваться услугами</a>
    </div><!--inside-->
  </div>
  <div class="item">
    <img src="assets/images/slider-light.svg" alt="slider">
    <div class="inside">
      <h2>OCTOPUS</h2>
      <p>Существует почти по всем городам России</p>
      <!--<a href="service-page.html" class="custom-btn">Get Started Now</a>-->
    </div><!--inside-->
  </div>
</div>
<!--===================== End of Base Slider ========================-->
<section class="bg-gray">
  <div class="container">
    <!--===================== Partner ========================-->
    <!-- <div class="partner animatedParent">
      <h5>Более 150,000+ счастливых абонентов, наши партнеры:</h5>
      <div class="partner-slider owl-carousel owl-theme">
        <div class="item animated bounceInLeft delay-250"><a href="#"><img src="https://zavodkpd.ru/wp-content/themes/kpd/img/logo.png" alt="partner"></a></div>
        <div class="item animated bounceInLeft delay-500"><a href="#"><img src="assets/images/brand.png" alt="partner"></a></div>
        <div class="item animated bounceInLeft delay-750"><a href="#"><img src="assets/images/brand.png" alt="partner"></a></div>
        <div class="item animated bounceInLeft delay-1000"><a href="#"><img src="assets/images/brand.png" alt="partner"></a></div>
        <div class="item animated bounceInLeft delay-1250"><a href="#"><img src="assets/images/brand.png" alt="partner"></a></div>
      </div>
    </div> -->
    <!--===================== End of Partner ========================-->
    <!--===================== Why Choose ========================-->
    <div class="why-choose">
      <h2 class="title-head">Что мы предлагаем?</h2>
      <div class="row">
        <div class="col-md-4 col-xs-12">
          <div class="inside">
            <img src="assets/images/optimised.svg" alt="optimised">
            <a href="#">Высокую скорость</a>
            <p>Высокая скорость и оптимизированный трафик стоит в основе нашей концепции</p>
            <!--<a href="#" class="read-more">Learn More <img src="assets/images/right.png" alt="right"></a>-->
          </div><!--inside-->
        </div>
        <div class="col-md-4 col-xs-12">
          <div class="inside">
            <img src="assets/images/powerfull.svg" alt="powerfull">
            <a href="#">Высококвалифицированных специалистов</a>
            <p>Мы отбираем лучших из лучших, чтобы клиент не заботился ни о чем</p>
            <!--<a href="#" class="read-more">Learn More <img src="assets/images/right.png" alt="right"></a>-->
          </div><!--inside-->
        </div>
        <div class="col-md-4 col-xs-12">
          <div class="inside">
            <img src="assets/images/website.svg" alt="website">
            <a href="#">Круглосуточную поддержку</a>
            <p>Мы обеспечиваем техническую и информационную поддержку наших клиентов 24 / 7 </p>
            <!--<a href="#" class="read-more">Learn More <img src="assets/images/right.png" alt="right"></a>-->
          </div><!--inside-->
        </div>
      </div>
    </div>
    <!--===================== End of Why Choose ========================-->
    <!--===================== Hosting Software ========================-->
    <div class="hosting-software">
      <h2 class="title-head">Наша статистика</h2>
      <ul id="counter">
        <li><b class="count" data-count="244">0</b><span>серверов</span></li>
        <li>до 300 <span>Мб/c скорость</span></li>
        <li><b class="count" data-count="15">0</b><span>регионов России</span></li>
        <li>150к<span>Довольных клиентов</span></li>
      </ul>
    </div>
    <!--===================== End of Hosting Software ========================-->
  </div>
</section>

<!--===================== User Slider ========================-->
<div class="user-slider">
  <div class="container">
    <div class="slider owl-carousel owl-theme">
      <div class="item">
        <div class="inside">
          <img src="assets/images/icon.svg" class="icon" alt="icon">
          <!--<img src="assets/images/brand.png" alt="logo-tesla">-->
          <p>Давно использую данного провайдера, все на высшем уровне</p>
          <div class="user">
            <a href="#">
              <img src="https://static.tildacdn.com/tild3265-3166-4537-a365-663265363636/45392923_19843500775.jpg" style="object-fit: cover; height: 58px" alt="user">
              Никитин Михаил
              <span>Пользователь</span>
            </a>
          </div><!--user-->
        </div><!--inside-->
      </div>
      <div class="item">
        <div class="inside">
          <img src="assets/images/icon.svg" class="icon" alt="icon">
          <!--<img src="assets/images/brand.png" alt="logo-tesla">-->
          <p>Очень нравится быстродействие тех. поддержки отвечают быстро, исправляют неисправности и аварии если случаются,  мгновенно, очень рад, что перешел к ним от конкурентов</p>
          <div class="user">
            <a href="#">
              <img src="https://i.pinimg.com/originals/14/71/0c/14710cb67f8693b2a754b002510dbb8c.jpg" style="object-fit: cover; height: 58px" alt="user">
              Владимир Милентьев
              <span>Житель г. Курск</span>
            </a>
          </div><!--user-->
        </div><!--inside-->
      </div>
    </div><!--slider-->
  </div>
</div>
<!--===================== End of User Slider ========================-->
<div class="container">
  <div class="info-pricing">
    <h4>Еще не передумали перейти в Octopus?</h4>
    <ul>
      <li>
        <h6>Легконастраиваемые тарифы</h6>
        <p>Мы гибки и подстраиваемся под клиента </p>
      </li>
      <li class="right">
        <h6>Защита нашей сети</h6>
        <p>Наши специалисты имеют многолетний опыт работы в IT и обезопасили сеть и защитили Вас от взлома</p>
      </li>
    </ul>
    <ul class="right">
      <li>
        <h6>Лучшее оборудование</h6>
        <p>Мы идем в ногу со временем и используем только современные технологии и оборудование</p>
      </li>
      <li class="button right">
        <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn">Попробовать сейчас</a>
      </li>
    </ul>
  </div><!--info-pricing-->
</div>
